import React, { useEffect, useState, useRef } from "react";
import { FxmsData } from "../../datas/FxData";
import { FxUtil } from "../../datas/FxUtil";
import { FxDataSearch } from "../../inputs/FxDataSearch";
import { FxFooter } from "../../inputs/FxFooter";
import { FxWindow } from "../../windows/FxWindows";
import { OpClass } from "../../datas/OpClass";
import { FxDataGrid, checkRowDatas } from "./FxDataGrid";

/**
 * FxCrud
 * 검색구역
 * 그리드구역
 * 버튼구역으로 구성된 전형적인 화면을 구성한다.
 *
 * 개발자 : T/F팀.
 * 개발년월 : 2022.11.
 * @param {*} props
 * @returns
 */

export const FxCrud = (props) => {
  const { menu } = props;
  const menuName = menu.opTitle;
  const [filter, setFilter] = useState(null);
  const [gridAttrList, setGridAttrList] = useState([]);
  const [rows, setRows] = useState([]);
  const [toolbar, setToolbar] = useState(null);
  const [projectTitle, setProjectTitle] = useState("Thingspire");
  const [thingsInfo, setThingsInfo] = useState("Thingspire");
  const [btnList, setBtnList] = useState([]);
  const [selectedGridData, setSelectedGridData] = useState(null);
  let keyIndexAttrList = [];

  let interval;
  let newInputData;
  let nowInputData = {};
  let index = 0;

  console.log("*** FxCrud ***   props",  props);

  /**
   * 그리드에서 선택한 데이터를 각 버튼에게 알린다.
   * @param {*} selectedData
   */
  function onClickRow(selectedData) {

    console.log("*** FxCrud ***  onClickRow ", selectedData);

    setSelectedGridData(selectedData);

    for (const data of btnList) {
      data.btnRef.current.disabled = selectedData === null;
      try {
        if (selectedData)
          data.resourceRef.current(selectedData.id, selectedData.row);
        else data.resourceRef.current(null, null);
      } catch (e) {
        console.log(data.attr.attrName, e, data.resourceRef.current);
      }
      data.attr.datas.selectedRow = selectedData;
    }
  }

  useEffect(() => {
    console.log("*** FxCrud *** did mount");

  });

  useEffect(() => {
    let inputDataOld = {};
    let opClass = OpClass.getOpClass(menu.opId);

    /**
     * 조회 버튼에 의해 호출된다.
     * @param {*} attr
     * @param {*} res
     */
    function onShowData(bret, opObj, res) {

      if (bret === false) {
        setRows([]);
        return;
      }

      checkRowDatas(res.data, keyIndexAttrList);
      setRows(res.data);
    }

    function onChangeDatas(datas) {
      console.log("*** FxCrud ***  onChangeDatas", datas);
      newInputData = datas;
    }

    function onButtonRef(newBtnList) {
      setBtnList(newBtnList);

      for (const b of newBtnList) {
        if (b.btnRef.current) {
          b.btnRef.current.disabled = true;
        }
      }
    }

    setProjectTitle(
      FxmsData.getVarValue("ui-title", "Thingspire Industrial Service Platform")
    );

    setThingsInfo(
      FxmsData.getVarValue(
        "ui-thingsInfo",
        "Thingspire Industrial Service Platform"
      )
    );

    if (opClass != null) {
      const [
        attrList,
        toolbarAttrList,
        gridAttrList,
        sortAttr,
        initOpClass,
        idAttrList,
      ] = opClass.getAttrInfo();
      keyIndexAttrList = idAttrList;


      function select() {
        try {
          FxmsData.selectGridData(
            initOpClass.getOpObj().opUri,
            newInputData ? newInputData : {},
            sortAttr ? sortAttr.attrName : null,
            sortAttr ? sortAttr.attrTypeCd : null
          ).then(function (res) {
            onShowData(true, initOpClass.getOpObj(), res);
            FxWindow.alert("[" + initOpClass.getOpObj().opName + "] " + res.data.length + " 건의 데이터가 조회되었습니다.");
          });
        } catch (error) {
          FxWindow.alert("조회중 오류가 발행되었습니다.", true);
        }
      }


      console.log("*** FxCrud *** sortAttr = ", sortAttr);

      // SELECT 버튼이 클릭되어 데이터가 조회되면 onShowData를 호출한다.
      for (const attr of attrList) {
        if (attr.isButton() && attr.linkOpObj && attr.linkOpObj.isSelect()) {
          attr.callback = onShowData;
        }
      }

      for (const attr of toolbarAttrList) {
        if (attr.isButton() && attr.linkOpObj && attr.linkOpObj.isDelete()) {
          attr.callback = select;
        }

        if (attr.isButton() && attr.linkOpObj &&  attr.attrDftVal== "create") {
          attr.callback = select;  
        } 
        
        if (attr.isButton() && attr.linkOpObj &&  attr.attrDftVal== "update") {
          attr.callback = select;  
        }  
      }

      setFilter(
        <FxDataSearch
          attrList={attrList}
          // onShowData={onShowData}
          onChangeDatas={onChangeDatas}
          inputType="Search"
        />
      );

      setToolbar(
        <FxDataSearch
          attrList={toolbarAttrList}
          inputType="Toolbar"
          onButtonRef={onButtonRef}
        />
      );

      gridAttrList.callback = select;

      setGridAttrList(gridAttrList);


      // 기본 select가 있으면 조회한다.
      if (initOpClass) {
        //setTimeout(select, 1000);
      }

      // 자동으로 데이터를 보일경우 ( 주석처리함 )
       const callUrl = initOpClass ? initOpClass.getOpObj().opUri : null;
      //const callUrl = null;

      if (callUrl != null) {
        interval = setInterval(function () {
          try {
            if (FxUtil.isSameObject(nowInputData, newInputData) === false || index === 0) {
              nowInputData = { ...newInputData };
              if (FxUtil.isSameObject(nowInputData, inputDataOld) === false || index === 0) {
                select();
                inputDataOld = { ...nowInputData };
              }
            }
          } catch (error) {
            console.log("*** FxCrud *** error ", error);
          }
          index++;
        }, 1000);
      } else {
        interval = null;
      }
    }

    return () => {
      if (interval != null) {
        clearInterval(interval);
      }

      console.log("*** FxCrud ***  9 ");
    };
  }, []);

  const iconstyled = {
    "& .MuiIconButton-root:": {
      color: "#00d1ff",
    },
  };

  const filterImg = (projectTitle) => {
    return projectTitle === "FlareStack"
      ? "/factory_img.png"
      : "/sectionObject.png";
  };

  return (
    <>
      {/* <div className="filterMenuName">
        {projectTitle} > {menuName}
      </div>
      <div className="filterThingsInfo">{thingsInfo}</div>
      <div className="filterImg">
        <img src={filterImg(projectTitle)} />
      </div> */}
      <div className="FxCrudFilter">{filter}</div>
      <div className="FxCrudDataGrid">
        <FxDataGrid
          attrList={gridAttrList}
          rows={rows}
          className={iconstyled}
          onClickRow={onClickRow}
          menuFullName={menu.menuFullName}
        />
        <div className="FxCrudToolbar">{toolbar}</div>
      </div>
      <FxFooter />
    </>
  );
}
